export const getTravelSearchIdFromSession = (): string | null => {
  try {
    if (typeof window === 'undefined') {
      return null
    }

    const travelSearchId = sessionStorage.getItem('tsTravelSearchId')
    return travelSearchId
  } catch {
    return null
  }
}
